/**
 * Application constants
 */

// API Routes
export const API_ROUTES = {
  AUTH: {
    CSRF: '/auth/csrf/',
    LOGIN: '/auth/login/',
    LOGOUT: '/auth/logout/',
    REFRESH: '/auth/refresh/',
    ME: '/auth/me/',
  },
  USERS: {
    PROFILE: '/users/profile/',
    PROFILE_UPDATE: '/users/profile/update/',
  },
  GADS: {
    LIST: '/gads/',
    ACTIVE: '/gads/active/',
    DETAIL: (id: number) => `/gads/${id}/`,
    SETTINGS: (id: number) => `/gads/${id}/settings/`,
  },
  GAD_MEMBERS: '/gad-members/',
  BUDGETS: '/budget-line-items/',
  PARTIES: '/parties/',
  PAYMENT_JUSTIFICATIONS: '/payment-justifications/',
  CHOICES: (appLabel: string, modelName: string, fieldName: string) =>
    `/choices/${appLabel}/${modelName}/${fieldName}/`,
} as const;

// App Routes (Spanish)
export const APP_ROUTES = {
  HOME: '/',
  SIGNIN: '/iniciar-sesion',
  FORBIDDEN: '/acceso-denegado',
  NOT_FOUND: '/no-encontrado',
  DASHBOARD: '/',
  BUDGETS: '/partidas-presupuestarias',
  PARTIES: '/terceros',
  PAYMENT_JUSTIFICATIONS: '/justificaciones-pago',
  SETTINGS: {
    ROOT: '/configuraciones',
    GENERAL: '/configuraciones/general',
    MEMBERS: '/configuraciones/miembros',
  },
  PROFILE: {
    ROOT: '/perfil',
    PERSONAL: '/perfil/datos-personales',
  },
} as const;

// Query Keys for React Query
export const QUERY_KEYS = {
  AUTH: {
    USER: ['auth', 'user'],
  },
  PROFILE: ['profile'],
  BUDGETS: {
    ALL: ['budgets'],
    DETAIL: (id: string) => ['budgets', id],
  },
  PARTIES: {
    ALL: ['parties'],
    DETAIL: (id: string) => ['parties', id],
  },
  PAYMENT_JUSTIFICATIONS: {
    ALL: ['payment-justifications'],
    DETAIL: (id: string) => ['payment-justifications', id],
  },
  CHOICES: (appLabel: string, modelName: string, fieldName: string) => ['choices', appLabel, modelName, fieldName],
} as const;

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;
